// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "App";
import { useContext, useState } from "react";
import { SelectedUserContext } from "../../index";
import MDInput from "components/MDInput";
import Swal from "sweetalert2";
import UsersApi from "../../../../../Classes/API/UsersApi";
import CreateUserReq from "../../../../../Classes/Models/Requests/Users/CreateUserReq";

function UserInfoCard({ setEditMode }) {
  const User = useContext(SelectedUserContext);
  const [Salary, setSalary] = useState(User.salary);
  const { translations } = useContext(LanguageContext);

  const UpdateSalary = async () => {
    let user = new CreateUserReq();
    user.salary = Salary;
    user.id = User.id;
    let res = await UsersApi.SetUserSalary(user);
    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");
      window.location.reload();
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return "Invalid Date";
    }
  };

  const calculateAgeFromBirthday = (birthdayDate) => {
    if (!birthdayDate) return null;
    try {
      const birthDate = new Date(birthdayDate);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    } catch (error) {
      return null;
    }
  };

  const displayAge = User.birthdayDate
    ? calculateAgeFromBirthday(User.birthdayDate)
    : User.age;

  return (
    <Card sx={{ height: "100%", boxShadow: !false && "none" }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pt={2}
        px={2}
      >
        <MDTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
        >
          {translations.userManagementInfoUserSettingUserInfo}
        </MDTypography>
        <MDTypography variant="body2" color="secondary">
          <Icon
            onClick={() => setEditMode(true)}
            sx={{ cursor: "pointer", "&:hover": { color: "primary.main" } }}
          >
            edit
          </Icon>
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <MDBox>
          {/* Birthday Information */}
          {!User.birthdayDate && (
            <MDBox
              sx={{ backgroundColor: "#fff3cd", p: 2, borderRadius: 1, mb: 2 }}
            >
              <MDTypography
                variant="body2"
                color="warning.main"
                fontWeight="medium"
              >
                ⚠️ Please add your birthday date.
              </MDTypography>
            </MDBox>
          )}

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoBirthday ||
                "Birthday"}
              : &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;
              {User.birthdayDate ? formatDate(User.birthdayDate) : "NOT SET"}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoUserAge} &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{displayAge || "N/A"}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoFoundBy}:
              &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.foundBy}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfogender}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.gender}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoUserId}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.id}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoName}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.name}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoPhone}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.number}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoCurrentBalance}
              : &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;
              {User.getLastBalanceEntry
                ? "$" + User.getLastBalanceEntry.currentBalance
                : "NO BALANCE ENTRIES YET"}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoUserType}:
              &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.userType}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoEmail}: &nbsp;
            </MDTypography>
            <MDTypography
              sx={{
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
              variant="button"
              fontWeight="regular"
              color="text"
            >
              &nbsp;{User.email}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoNationality}:
              &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.nationality}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {
                translations.userManagementInfoUserSettingUserInfoNationalityGroup
              }
              : &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.nationalityGroup}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoNationalID}:
              &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.nationalId}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoRelativeNumber}
              : &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.relativeNumber}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {
                translations.userManagementInfoUserSettingUserInfoChronicDiseases
              }
              : &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.chronicDiseases}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoSensitivity}:
              &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.sensitivity}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoMedications}:
              &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.medications}
            </MDTypography>
          </MDBox>

          {(User.userType === "AccountingEmployee" ||
            ["Admin", "Owner", "HeadAccounting"].includes(User.userType) ||
            User.userType === "AppointmentEmployee" ||
            User.userType === "CallCenterEmployee" ||
            User.userType === "Therapist" ||
            User.userType === "FloorManager") && (
            <>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems="left"
                py={1}
                pr={2}
                gap={2}
              >
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  textTransform="capitalize"
                  sx={{ mb: { xs: 1, sm: 0 } }}
                >
                  {translations.userManagementInfoUserSettingUserInfoSetSalary}
                </MDTypography>
                <MDInput
                  type="number"
                  onChange={(e) => setSalary(e.target.value)}
                  defaultValue={User.salary}
                  label={"Salary"}
                  sx={{
                    width: "100px",
                    fontSize: "16px",
                    mb: { xs: 1, sm: 0 },
                  }}
                />
                <button
                  className="btn btn-success"
                  onClick={() => UpdateSalary()}
                  style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {translations.userManagementInfoUserSettingUserInfoSetSalary}
                </button>
              </MDBox>

              <MDBox display="flex" py={1} pr={2}>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {
                    translations.userManagementInfoUserSettingUserInfoLastSalaryPayment
                  }
                  : &nbsp;
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  &nbsp;
                  {User.lastSalaryPayment
                    ? User.lastSalaryPayment
                    : "NO SALARY PAYMENTS YET"}
                </MDTypography>
              </MDBox>
            </>
          )}
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default UserInfoCard;
